module.exports = __webpack_public_path__ + "img/Alternative-Packaging-Solutions-1110x450.58711a05.png";